module.exports = __webpack_public_path__ + "images/market/introduction/2_88f7dbf08a74d577686d78599fa1a7fc.png";